import { SentInvoice } from 'types/sentInvoices';
import { portalAPI } from './portalAPI';

export const APISentInvoicesSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['SentInvoices'] }).injectEndpoints({
    endpoints: (builder) => ({
        getSentInvoicesList: builder.query<SentInvoice[], number>({
            query: (invoiceId) => `v1/invoices/${invoiceId}/sent-invoices`,
            providesTags: ['SentInvoices'],
        }),
        uploadSentInvoice: builder.mutation<
            SentInvoice,
            { invoiceId: number; file: File; sentDateTime: string; invoiceStatusTypeCode?: string }
        >({
            query: ({ invoiceId, file, sentDateTime, invoiceStatusTypeCode = 'SENT' }) => {
                const formData = new FormData();
                formData.append('invoicePdf', file);
                return {
                    url: `v1/invoices/${invoiceId}/sent-invoices?sentDateTime=${encodeURIComponent(
                        sentDateTime
                    )}&invoiceStatusTypeCode=${invoiceStatusTypeCode}`,
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: ['SentInvoices'],
        }),
        deleteSentInvoice: builder.mutation<void, number>({
            query: (sentInvoiceId) => ({
                url: `v1/invoices/sent-invoices/${sentInvoiceId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['SentInvoices'],
        }),
    }),
    overrideExisting: false,
});

export const { useGetSentInvoicesListQuery, useUploadSentInvoiceMutation, useDeleteSentInvoiceMutation } =
    APISentInvoicesSlice;
